import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";

type props = {};

export const PaymentExpandedHeader: React.FC<props> = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        gap: 10,
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: Colors.green,
          width: 24,
          height: 24,
          borderRadius: 12,
        }}>
        <TCText
          style={{ fontWeight: 600, fontSize: 12, color: "white" }}
          value="$"
        />
      </div>
      <TCText
        style={{ color: Colors.green, fontWeight: 600, fontSize: 14 }}
        value="Price for this booking"
      />
    </div>
  );
};
